/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
const vimeTags = [
    'vime-audio',
    'vime-caption-control',
    'vime-captions',
    'vime-click-to-play',
    'vime-control',
    'vime-control-group',
    'vime-control-spacer',
    'vime-controls',
    'vime-current-time',
    'vime-dailymotion',
    'vime-dash',
    'vime-dbl-click-fullscreen',
    'vime-default-controls',
    'vime-default-settings',
    'vime-default-ui',
    'vime-embed',
    'vime-end-time',
    'vime-faketube',
    'vime-file',
    'vime-fullscreen-control',
    'vime-hls',
    'vime-icon',
    'vime-icons',
    'vime-live-indicator',
    'vime-menu',
    'vime-menu-item',
    'vime-menu-radio',
    'vime-menu-radio-group',
    'vime-mute-control',
    'vime-pip-control',
    'vime-playback-control',
    'vime-player',
    'vime-playground',
    'vime-poster',
    'vime-scrim',
    'vime-scrubber-control',
    'vime-settings',
    'vime-settings-control',
    'vime-skeleton',
    'vime-slider',
    'vime-spinner',
    'vime-submenu',
    'vime-time',
    'vime-time-progress',
    'vime-tooltip',
    'vime-ui',
    'vime-video',
    'vime-vimeo',
    'vime-volume-control',
    'vime-youtube',
];
Vue.config.ignoredElements = [...Vue.config.ignoredElements, ...vimeTags];
import VimeAudioProxy from './components/VimeAudio';
import VimeCaptionControlProxy from './components/VimeCaptionControl';
import VimeCaptionsProxy from './components/VimeCaptions';
import VimeClickToPlayProxy from './components/VimeClickToPlay';
import VimeControlProxy from './components/VimeControl';
import VimeControlGroupProxy from './components/VimeControlGroup';
import VimeControlSpacerProxy from './components/VimeControlSpacer';
import VimeControlsProxy from './components/VimeControls';
import VimeCurrentTimeProxy from './components/VimeCurrentTime';
import VimeDailymotionProxy from './components/VimeDailymotion';
import VimeDashProxy from './components/VimeDash';
import VimeDblClickFullscreenProxy from './components/VimeDblClickFullscreen';
import VimeDefaultControlsProxy from './components/VimeDefaultControls';
import VimeDefaultSettingsProxy from './components/VimeDefaultSettings';
import VimeDefaultUiProxy from './components/VimeDefaultUi';
import VimeEmbedProxy from './components/VimeEmbed';
import VimeEndTimeProxy from './components/VimeEndTime';
import VimeFaketubeProxy from './components/VimeFaketube';
import VimeFileProxy from './components/VimeFile';
import VimeFullscreenControlProxy from './components/VimeFullscreenControl';
import VimeHlsProxy from './components/VimeHls';
import VimeIconProxy from './components/VimeIcon';
import VimeIconsProxy from './components/VimeIcons';
import VimeLiveIndicatorProxy from './components/VimeLiveIndicator';
import VimeMenuProxy from './components/VimeMenu';
import VimeMenuItemProxy from './components/VimeMenuItem';
import VimeMenuRadioProxy from './components/VimeMenuRadio';
import VimeMenuRadioGroupProxy from './components/VimeMenuRadioGroup';
import VimeMuteControlProxy from './components/VimeMuteControl';
import VimePipControlProxy from './components/VimePipControl';
import VimePlaybackControlProxy from './components/VimePlaybackControl';
import VimePlayerProxy from './components/VimePlayer';
import VimePlaygroundProxy from './components/VimePlayground';
import VimePosterProxy from './components/VimePoster';
import VimeScrimProxy from './components/VimeScrim';
import VimeScrubberControlProxy from './components/VimeScrubberControl';
import VimeSettingsProxy from './components/VimeSettings';
import VimeSettingsControlProxy from './components/VimeSettingsControl';
import VimeSkeletonProxy from './components/VimeSkeleton';
import VimeSliderProxy from './components/VimeSlider';
import VimeSpinnerProxy from './components/VimeSpinner';
import VimeSubmenuProxy from './components/VimeSubmenu';
import VimeTimeProxy from './components/VimeTime';
import VimeTimeProgressProxy from './components/VimeTimeProgress';
import VimeTooltipProxy from './components/VimeTooltip';
import VimeUiProxy from './components/VimeUi';
import VimeVideoProxy from './components/VimeVideo';
import VimeVimeoProxy from './components/VimeVimeo';
import VimeVolumeControlProxy from './components/VimeVolumeControl';
import VimeYoutubeProxy from './components/VimeYoutube';
export const VimeAudio = /*#__PURE__*/ VimeAudioProxy;
export const VimeCaptionControl = /*#__PURE__*/ VimeCaptionControlProxy;
export const VimeCaptions = /*#__PURE__*/ VimeCaptionsProxy;
export const VimeClickToPlay = /*#__PURE__*/ VimeClickToPlayProxy;
export const VimeControl = /*#__PURE__*/ VimeControlProxy;
export const VimeControlGroup = /*#__PURE__*/ VimeControlGroupProxy;
export const VimeControlSpacer = /*#__PURE__*/ VimeControlSpacerProxy;
export const VimeControls = /*#__PURE__*/ VimeControlsProxy;
export const VimeCurrentTime = /*#__PURE__*/ VimeCurrentTimeProxy;
export const VimeDailymotion = /*#__PURE__*/ VimeDailymotionProxy;
export const VimeDash = /*#__PURE__*/ VimeDashProxy;
export const VimeDblClickFullscreen = /*#__PURE__*/ VimeDblClickFullscreenProxy;
export const VimeDefaultControls = /*#__PURE__*/ VimeDefaultControlsProxy;
export const VimeDefaultSettings = /*#__PURE__*/ VimeDefaultSettingsProxy;
export const VimeDefaultUi = /*#__PURE__*/ VimeDefaultUiProxy;
export const VimeEmbed = /*#__PURE__*/ VimeEmbedProxy;
export const VimeEndTime = /*#__PURE__*/ VimeEndTimeProxy;
export const VimeFaketube = /*#__PURE__*/ VimeFaketubeProxy;
export const VimeFile = /*#__PURE__*/ VimeFileProxy;
export const VimeFullscreenControl = /*#__PURE__*/ VimeFullscreenControlProxy;
export const VimeHls = /*#__PURE__*/ VimeHlsProxy;
export const VimeIcon = /*#__PURE__*/ VimeIconProxy;
export const VimeIcons = /*#__PURE__*/ VimeIconsProxy;
export const VimeLiveIndicator = /*#__PURE__*/ VimeLiveIndicatorProxy;
export const VimeMenu = /*#__PURE__*/ VimeMenuProxy;
export const VimeMenuItem = /*#__PURE__*/ VimeMenuItemProxy;
export const VimeMenuRadio = /*#__PURE__*/ VimeMenuRadioProxy;
export const VimeMenuRadioGroup = /*#__PURE__*/ VimeMenuRadioGroupProxy;
export const VimeMuteControl = /*#__PURE__*/ VimeMuteControlProxy;
export const VimePipControl = /*#__PURE__*/ VimePipControlProxy;
export const VimePlaybackControl = /*#__PURE__*/ VimePlaybackControlProxy;
export const VimePlayer = /*#__PURE__*/ VimePlayerProxy;
export const VimePlayground = /*#__PURE__*/ VimePlaygroundProxy;
export const VimePoster = /*#__PURE__*/ VimePosterProxy;
export const VimeScrim = /*#__PURE__*/ VimeScrimProxy;
export const VimeScrubberControl = /*#__PURE__*/ VimeScrubberControlProxy;
export const VimeSettings = /*#__PURE__*/ VimeSettingsProxy;
export const VimeSettingsControl = /*#__PURE__*/ VimeSettingsControlProxy;
export const VimeSkeleton = /*#__PURE__*/ VimeSkeletonProxy;
export const VimeSlider = /*#__PURE__*/ VimeSliderProxy;
export const VimeSpinner = /*#__PURE__*/ VimeSpinnerProxy;
export const VimeSubmenu = /*#__PURE__*/ VimeSubmenuProxy;
export const VimeTime = /*#__PURE__*/ VimeTimeProxy;
export const VimeTimeProgress = /*#__PURE__*/ VimeTimeProgressProxy;
export const VimeTooltip = /*#__PURE__*/ VimeTooltipProxy;
export const VimeUi = /*#__PURE__*/ VimeUiProxy;
export const VimeVideo = /*#__PURE__*/ VimeVideoProxy;
export const VimeVimeo = /*#__PURE__*/ VimeVimeoProxy;
export const VimeVolumeControl = /*#__PURE__*/ VimeVolumeControlProxy;
export const VimeYoutube = /*#__PURE__*/ VimeYoutubeProxy;
//# sourceMappingURL=components.js.map